import { NavLink } from '../models/header';
import { RoutePaths } from './routes';

export const links: NavLink[] = [
  { name: 'FAQs', route: RoutePaths.FAQ, isActive: false },
  { name: 'Privacy Policy', route: RoutePaths.PRIVACY_POLICY, isActive: false },
  { name: 'Do Not Sell My Details', route: RoutePaths.FCC, isActive: false },
  {
    name: 'Terms & Conditions',
    route: RoutePaths.TERMS_AND_CONDITIONS,
    isActive: false,
  },
  { name: 'Cookies', route: RoutePaths.COOKIE_POLICY, isActive: false },
];
